import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_info",
  "use": "svg_info-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"svg_info\"><path d=\"M13.667 7A6.667 6.667 0 1 0 7 13.667 6.675 6.675 0 0 0 13.667 7Zm-.833 0A5.834 5.834 0 1 1 7 1.167 5.84 5.84 0 0 1 12.833 7ZM7.61 4.525h-1.24v-1.24h1.24v1.24ZM6.377 5.753H7.63v4.963H6.377V5.753Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol